import { gql } from '@apollo/client'

export default gql(`
    mutation createUser($accessRoleGroups: [ID] $id: String $name: String $project: String $ip: [String]) {
        createUser(
            input: {
                id: $id
                name: $name
                accessRoleGroups: $accessRoleGroups
                ip: $ip
            }
            project: $project
        ){
            id
            status
            name
            enabled
            status
            lastLogin
            ip
            accessRoleGroups {
              id
              name
              modules{
                name
                permissions
              }
            }
        }
    }
`)
